import React, { useState, useEffect } from "react";
import { Navbar, Button } from "flowbite-react";
// import logo from "../img/logo.svg";
import logo from "../../../img/logo.svg";
import { handlerGetProfiles, handleProfileSelection } from "./handler";
import { useSearchParams, useNavigate } from "react-router-dom";
import { VscChromeClose } from "react-icons/vsc";

const DisplayProfileList = (props) => {

    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const redirectToDocument = searchParams.get("redirectToDocument");
    const profileType = searchParams.get("profileType");
    const changeProfile = searchParams.get("changeProfile");
    const serviceIdentifier = searchParams.get("serviceIdentifier");

    const [profilePageHeader, setProfilePageHeader] = useState("Applying to drive as a");
    const [profilePageDescription, setProfilePageDescription] = useState("");

    if(changeProfile == "true") {
        sessionStorage.setItem("changeProfile", "true")
    }
    const [profileList, setProfileList] = useState([]);

    useEffect(() => {
        handlerGetProfiles(navigate, setProfileList, changeProfile, redirectToDocument, profileType, serviceIdentifier, setProfilePageHeader, setProfilePageDescription)
    }, [])

    return (
        <>
            <Navbar fluid={true} rounded={true} className="shadow mb-3">
                
                {/* <Navbar.Brand>
                    <img src={logo} className="mr-3 ml-2 h-8 sm:h-10" alt="Ryde" />
                    <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
                    </span>
                </Navbar.Brand> */}

                <a
                  href={"rydedriver://open?action=home"}
                  onClick={() => {
                    window.location.href = "rydedriver://open?action=home";
                  }}
                >
                  <Navbar.Brand>
                    <div style={{ padding: "10px" }}>
                      <VscChromeClose />
                    </div>
                    <span className="self-center whitespace-nowrap text-md font-semibold dark:text-white">
                      Back to Home
                    </span>
                  </Navbar.Brand>
                </a>

                <div className="flex md:order-2"></div>

                

            </Navbar>
            {
                profileList.length > 0 &&
            <div className="mt-5 m-auto w-full max-w-md p-4 bg-white rounded-lg sm:p-0 sm:mt-10 dark:bg-gray-800 dark:border-gray-700" style={{ paddingTop: "64px" }}>
                
                {/*  STEP 1 */}
                
                <div className="mb-4">
                    <h1 className="text-2xl mb-4 font-bold leading-none text-gray-900 dark:text-white">
                        {/* Applying to drive as a */}
                        {profilePageHeader}
                    </h1>
                </div>

                {/*  STEP 2 */}
                {
                    profilePageDescription !== "" &&
                    <div className="mb-4">
                        <p className='mb-8 text-gray-600'>{profilePageDescription}</p>
                    </div>
                }
                


                {/* STEP 3 */}
                <div className="flow-root doc-list">
                    <ul role="list" className="divide-y divide-gray-200 dark:divide-gray-700">
                        {
                            profileList.map((profile, index) => {
                                return (
                                    
                                    <li className="py-3 sm:py-4 hover:shadow-md" key={profile.profileId} >
                                        <div className="flex items-center space-x-4" onClick={() => handleProfileSelection(profile, navigate)}>
                                            <div className="flex-1 min-w-0">
                                                <p className="font-medium text-gray-900 truncate dark:text-white">
                                                    {profile.profileName}
                                                </p>
                                            </div>
                                        </div>
                                    </li>
                                    
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
            }
        </>
    )
}

export default DisplayProfileList;